import { useState, useEffect } from "react";

const SendMsg = ({
  index,
  customers,
  MsgHandler,
  Shop,
  Products,
  modalMsg,
  MsgHandlerGroup,
  modalUpdate,
}) => {
  const [sendWith, setSendWith] = useState([0, 0]);
  const [sendWith2, setSendWith2] = useState([0, 0]);
  const [Msg, setMsg] = useState("");
  const [Msg2, setMsg2] = useState("");
  useEffect(() => {
    setMsg("");
    setMsg2("");
    setSendWith([0, 0]);

    setSendWith2([0, 0]);
  }, [modalUpdate]);
  return (
    <>
      <div
        className="modal fade"
        id={`SendMsgModal`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{ justifyContent: "end" }}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                ارسال پیام
              </h5>
              <button
                type="button"
                className="btn btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body modlatrashposition">
              <div>
                <form>
                  <div>
                    <textarea
                      id="Msg"
                      className="form-control mb-2"
                      value={Msg}
                      onChange={(e) => setMsg(e.target.value)}
                    />
                  </div>
                  <div class="form-check">
                    <input
                      onClick={(e) => {
                        let array = [...sendWith];
                        array[0] = e.target.checked;
                        setSendWith(array);
                      }}
                      class="form-check-input"
                      type="checkbox"
                      checked={sendWith[0]}
                      id="sendEmail"
                    />
                    <label class="form-check-label" for="sendEmail">
                      ارسال ایمیل
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      onClick={(e) => {
                        let array = [...sendWith];
                        array[1] = e.target.checked;
                        setSendWith(array);
                      }}
                      class="form-check-input"
                      type="checkbox"
                      checked={sendWith[1]}
                      id="sendSMS"
                    />
                    <label class="form-check-label" for="sendSMS">
                      ارسال پیامک
                    </label>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                لغو
              </button>
              <button
                type="button"
                onClick={() => {
                  MsgHandler(false, sendWith, Msg, customers[index].users__id);
                  setSendWith([0, 0]);
                }}
                className="btn btn-danger btn-sm"
                data-bs-dismiss="modal"
              >
                ارسال
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id={`SendMsgModal2`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{ justifyContent: "end" }}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                ارسال پیام
              </h5>
              <button
                type="button"
                className="btn btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body modlatrashposition">
              <div>
                <>
                  <form>
                    <div>
                      <textarea
                        id="Msg"
                        className="form-control"
                        value={Msg2}
                        onChange={(e) => setMsg2(e.target.value)}
                      />
                    </div>
                    <div class="form-check">
                      <input
                        onClick={(e) => {
                          let array = [...sendWith2];
                          array[0] = e.target.checked;
                          setSendWith2(array);
                        }}
                        class="form-check-input"
                        type="checkbox"
                        checked={sendWith2[0]}
                        id="sendEmail2"
                      />
                      <label class="form-check-label" for="sendEmail2">
                        ارسال ایمیل
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        onClick={(e) => {
                          let array = [...sendWith2];
                          array[1] = e.target.checked;
                          setSendWith2(array);
                        }}
                        class="form-check-input"
                        type="checkbox"
                        checked={sendWith2[1]}
                        id="sendSMS2"
                      />
                      <label class="form-check-label" for="sendSMS2">
                        ارسال پیامک
                      </label>
                    </div>
                  </form>
                </>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                لغو
              </button>
              <button
                type="button"
                onClick={() => {
                  MsgHandler(true, sendWith, Msg);
                  setSendWith2([0, 0]);
                }}
                className="btn btn-danger btn-sm"
                data-bs-dismiss="modal"
              >
                ارسال
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendMsg;
